import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.tsx';
import './styles/tokens.css';
import './styles/page.css';
import './styles/demo-overlay.css';
import './styles/local-polish.css';
import './styles/legal.css';

createRoot(document.getElementById('root')!).render(
  <StrictMode><App /></StrictMode>,
);




import './styles/buyer-sections.css';
import './styles/navigation.css';
import './styles/story.css';
import './styles/showcase.css';
import './styles/headings.css';
